import { render, staticRenderFns } from "./editorForm.vue?vue&type=template&id=aff4579e&scoped=true"
import script from "./editorForm.vue?vue&type=script&lang=js"
export * from "./editorForm.vue?vue&type=script&lang=js"
import style0 from "./editorForm.vue?vue&type=style&index=0&id=aff4579e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff4579e",
  null
  
)

export default component.exports